export async function enableMocking() {
  return;
  // if (import.meta.env.MODE !== 'development') {
  //   return;
  // }
  const { worker } = await import('./browser');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start({ quiet: true });
}
